import React, { useCallback, useContext, useEffect, useMemo, useState } from "react";
import Tab from "../components/Tab";
import TabActivityInfo from "./Tab/TabActivityInfo";
import TabActivityLocation from "./Tab/TabActivityLocation";
import TabActivityOrganization from "./Tab/TabActivityOrganization";
import TabActivity from "./Tab/TabActivity";
import TabActivitySummary from "./Tab/TabActivitySummary";
import TabActivityReport from "./Tab/TabActivityReport";
import { useParams } from "react-router-dom";
import { UserContext } from '../components/MyContext';
import AppShell from "../components/AppShell";
import { FaChartPie, FaExclamationTriangle, FaFileAlt, FaInfoCircle, FaLeaf, FaMapMarkedAlt, FaSitemap } from "react-icons/fa";
import axios from 'axios';
import config from '../config';

function ActivityDetail() {
  const { years, fac_id } = useParams();
  const { userData } = useContext(UserContext);
  const [refreshFlag, setRefreshFlag] = useState(false);
  const [isSystemOpen, setIsSystemOpen] = useState(true);
  const [isSystemOpenResolved, setIsSystemOpenResolved] = useState(false);

  const handleRefreshAll = () => {
    // Toggle flag เพื่อบังคับ child components ใช้ useEffect ใหม่
    setRefreshFlag(prev => !prev);
  };

  const fetchSystemOpen = useCallback(async () => {
    try {
      const yearAD = Number(years) - 543;
      const res = await axios.get(`${config.urlApi}/activity/showPeriod/${fac_id}`);

      if (res.status === 200 && Array.isArray(res.data)) {
        const currentPeriod = res.data.find((item) => Number(item.years) === yearAD);
        const isOpenRaw = currentPeriod?.is_open;
        const nextIsOpen = isOpenRaw === true || isOpenRaw === 1 || isOpenRaw === '1';
        setIsSystemOpen(nextIsOpen);
      } else {
        setIsSystemOpen(false);
      }
    } catch (error) {
      console.log('fetchSystemOpen error:', error.message);
      setIsSystemOpen(false);
    } finally {
      setIsSystemOpenResolved(true);
    }
  }, [fac_id, years]);

  useEffect(() => {
    fetchSystemOpen();
  }, [fetchSystemOpen]);

  // Wrapper component to prevent custom props from reaching DOM
  const TabPane = ({ label, tabIcon, tabSubtitle, children }) => (
    <>{children}</>
  );

  const pageNotice = useMemo(() => {
    if (!isSystemOpenResolved || isSystemOpen) {
      return null;
    }

    return (
      <div className="app-status-notice app-status-notice--warning" role="alert">
        <span className="app-status-notice__icon"><FaExclamationTriangle /></span>
        <div className="app-status-notice__copy">
          <strong>ขณะนี้ระบบปิดการกรอกข้อมูล</strong>
          <span>กรุณารอรอบถัดไป</span>
        </div>
      </div>
    );
  }, [isSystemOpen, isSystemOpenResolved]);

  return (
    <AppShell
      page="activityDetail"
      contentPreset="form"
      title={`ข้อมูล Landscape หน่วยงาน ${userData.facultyName || '-'} ปี ${years}`}
      subtitle="จัดการข้อมูลทั่วไป แผนภาพองค์กร โครงสร้างองค์กร กิจกรรมแหล่งปล่อย และรายงานในหน้าเดียว"
      notice={pageNotice}
    >
      <div className="row">
        <div className="col-12">
          <div className="card">
            <Tab variant="detail" className="app-activity-tabset">
              <TabPane label="ข้อมูลทั่วไป" tabIcon={<FaInfoCircle />} tabSubtitle="รายละเอียดหน่วยงานและพิกัด">
                <TabActivityInfo onDataUpdated={handleRefreshAll}/>
              </TabPane>
              <TabPane label="แผนภาพองค์กร" tabIcon={<FaMapMarkedAlt />} tabSubtitle="ภาพประกอบพื้นที่และตำแหน่ง">
                <TabActivityLocation />
              </TabPane>
              <TabPane label="โครงสร้างองค์กร" tabIcon={<FaSitemap />} tabSubtitle="โครงสร้างการดำเนินงาน">
                <TabActivityOrganization />
              </TabPane>
              <TabPane label="กิจกรรมแหล่งปล่อย" tabIcon={<FaLeaf />} tabSubtitle="ข้อมูลกิจกรรมและปริมาณปล่อย">
                <TabActivity refresh={refreshFlag}/>
              </TabPane>
              <TabPane label="สรุปผลการคำนวณ" tabIcon={<FaChartPie />} tabSubtitle="ภาพรวม Scope และตัวชี้วัด">
                <TabActivitySummary refresh={refreshFlag}/>
              </TabPane>
              <TabPane label="รายงาน" tabIcon={<FaFileAlt />} tabSubtitle="สร้างและดาวน์โหลดรายงาน">
                <TabActivityReport />
              </TabPane>
            </Tab>
          </div>
        </div>
      </div>
    </AppShell>
  );
}

export default ActivityDetail;
